<template>
    <PhotoList></PhotoList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PhotoList = defineAsyncComponent(() =>
    import("../../components/Safety/PhotoList.vue")
);

export default {
    name: "Photo_List",
    components: { PhotoList, AuthLayout },
};
</script>
